import { captureApiError } from 'app/utils/errorMonitoring'

export const generateCorrelationId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
    const random = Math.floor(Math.random() * 16)
    const value = character === 'x' ? random : (random & 0x3) | 0x8
    return value.toString(16)
  })
}

export const applyRequestContext = (config = {}) => {
  const correlationId = generateCorrelationId()
  config.headers = config.headers || {}
  config.headers['x-correlation-id'] = correlationId
  config.metadata = { ...config.metadata, frontendCorrelationId: correlationId }
  return config
}

export const preserveApiErrorMetadata = (error) => {
  const responseData = error?.response?.data || {}
  const config = error?.config || {}
  const frontendCorrelationId = config.metadata?.frontendCorrelationId
  const responseCorrelationId =
    responseData.correlationId || error?.response?.headers?.['x-correlation-id']

  error.apiError = {
    status: error?.response?.status,
    message: responseData.message || error.message,
    code: responseData.code,
    requestId: responseData.requestId,
    correlationId: responseCorrelationId || frontendCorrelationId,
    frontendCorrelationId,
    details: responseData.details,
    path: config.url,
    method: config.method?.toUpperCase(),
  }
  return error
}

export const configureApiClient = (instance, { refreshToken } = {}) => {
  instance.interceptors.request.use(applyRequestContext, (error) => Promise.reject(error))

  instance.interceptors.response.use(
    (response) => response,
    async (rawError) => {
      const error = preserveApiErrorMetadata(rawError)
      const originalRequest = error.config || {}
      const shouldRefresh =
        (error.response?.status === 401 || error.response?.status === 403) &&
        !originalRequest._retry &&
        typeof refreshToken === 'function'

      if (shouldRefresh) {
        originalRequest._retry = true
        try {
          const newToken = await refreshToken()
          originalRequest.headers = originalRequest.headers || {}
          originalRequest.headers.authorizationToken = newToken
          return instance(originalRequest)
        } catch (_) {
          localStorage.removeItem('token')
          localStorage.removeItem('refreshToken')
        }
      }

      captureApiError(error)
      return Promise.reject(error)
    }
  )

  return instance
}

